__turbopack_context__.v({
  "large": "PhoneInputWithoutCode-module-scss-module__91FTWa__large",
  "middle": "PhoneInputWithoutCode-module-scss-module__91FTWa__middle",
  "phoneInput": "PhoneInputWithoutCode-module-scss-module__91FTWa__phoneInput",
  "placeholderColor": "PhoneInputWithoutCode-module-scss-module__91FTWa__placeholderColor",
});
